export { default } from './MeatingIcon';
